/**
 * TOSS scoring constants — mirrored from the canonical Deno scorer at
 * `supabase/functions/enhanced-market-analysis/scorer.ts`.
 *
 * This file exists because the scorer lives in a Deno edge function and cannot
 * be imported by the Vite frontend directly. Keep these values in sync.
 *
 * ⚠️ If `MAX_SCORES`, the rating thresholds, or the social boost cap change in
 * `scorer.ts`, update THIS file and the `/how-toss-works` page in the same PR.
 */

export const TOSS_MAX_SCORES = {
  momentum: 30,
  position: 20,
  technical: 20,
  fundamentals: 15,
  sentiment: 10,
  risk: 5,
} as const;

export const TOSS_BASE_TOTAL = Object.values(TOSS_MAX_SCORES).reduce(
  (a, b) => a + b,
  0,
);

/** Additive Social Boost applied on top of the base 100 (see social-signals memory). */
export const TOSS_SOCIAL_BOOST_MAX = 15;

export const TOSS_RATING_THRESHOLDS = {
  HOT_PICK: 80,
  STRONG_CONTENDER: 65,
  WATCHLIST: 50,
} as const;

export const TOSS_MARKET_CAP_RANGE = {
  minUsd: 10_000_000,
  maxUsd: 500_000_000,
} as const;
